import React from 'react'
import StopReasonCodes from '../features/stopReasonCodes'

export default function StopReasonCodesPage() {
  return (
    <StopReasonCodes />
  )
}
